/**
 * Guards for the floating dropdown layer (Radix poppers + TaskDropdown
 * portals). The expanded-mode submit shortcuts (click-outside, Enter)
 * must stay inert while any of these overlays is open — otherwise
 * confirming a badge dropdown would also submit and collapse the entry.
 */

const OPEN_LAYER_SELECTOR = '[data-radix-popper-content-wrapper], [data-task-dropdown]'
const TARGET_LAYER_SELECTOR = `${OPEN_LAYER_SELECTOR}, [data-task-dropdown-backdrop]`

/**
 * A floating dropdown is currently open anywhere in the document. A tooltip is no dropdown: it made
 * the Quick Add window grow by 420px and swallowed Escape (code review 03.10.2026).
 */
export function dropdownLayerOpen(): boolean {
  return [...document.querySelectorAll(OPEN_LAYER_SELECTOR)]
    .some(el => !el.firstElementChild?.classList.contains('tooltip-content'))
}

/** The event target sits inside the floating dropdown layer (incl. backdrops). */
export function targetInDropdownLayer(target: EventTarget | null): boolean {
  if (!(target instanceof Node)) return false
  const el = target instanceof Element ? target : target.parentElement
  return !!el?.closest(TARGET_LAYER_SELECTOR)
}
